export const LOGIN_REQUESTING = 'auth/LOGIN_REQUESTING';
export const LOGIN_SUCCESS = 'auth/LOGIN_SUCCESS';
export const LOGIN_FAILED = 'auth/LOGIN_FAILED';

export const TOKEN_REFRESH_SUCCESS = 'auth/TOKEN_REFRESH_SUCCESS';

export const FETCH_PROFILE_REQUESTING = 'auth/FETCH_PROFILE_REQUESTING';
export const FETCH_PROFILE_SUCCESS = 'auth/FETCH_PROFILE_SUCCESS';
export const FETCH_PROFILE_FAILED = 'auth/FETCH_PROFILE_FAILED';

export const UPDATE_PROFILE_REQUESTING = 'auth/UPDATE_PROFILE_REQUESTING';
export const UPDATE_PROFILE_SUCCESS = 'auth/UPDATE_PROFILE_SUCCESS';
export const UPDATE_PROFILE_FAILED = 'auth/UPDATE_PROFILE_FAILED';

export const CHANGE_PASSWORD_REQUESTING = 'auth/CHANGE_PASSWORD_REQUESTING';
export const CHANGE_PASSWORD_SUCCESS = 'auth/CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAILED = 'auth/CHANGE_PASSWORD_FAILED';

export const LOGOUT = 'auth/LOGOUT';
